import { ShapeTypes } from '@/types/shapes';
import Konva from 'konva';
export function getShapeHistoryObject(obj, meta) {
    try {
        let historyObject;
        switch (obj.type) {
            case ShapeTypes.SQUARE:
                historyObject = {
                    x: obj.x(),
                    y: obj.y(),
                    width: obj.width(),
                    height: obj.height(),
                    fill: obj.fill(),
                    stroke: obj.stroke(),
                    strokeWidth: obj.strokeWidth(),
                    opacity: obj.opacity(),
                    type: ShapeTypes.SQUARE,
                    scale: obj.scale(),
                    rotation: obj.rotation(),
                };
                break;
            case ShapeTypes.CIRCLE:
                historyObject = {
                    x: obj.x(),
                    y: obj.y(),
                    radius: obj.radius(),
                    fill: obj.fill(),
                    stroke: obj.stroke(),
                    strokeWidth: obj.strokeWidth(),
                    opacity: obj.opacity(),
                    type: ShapeTypes.CIRCLE,
                    scale: obj.scale(),
                    rotation: obj.rotation(),
                };
                break;
            case ShapeTypes.STAR:
                historyObject = {
                    x: obj.x(),
                    y: obj.y(),
                    numPoints: obj.numPoints(),
                    innerRadius: obj.innerRadius(),
                    outerRadius: obj.outerRadius(),
                    fill: obj.fill(),
                    stroke: obj.stroke(),
                    strokeWidth: obj.strokeWidth(),
                    opacity: obj.opacity(),
                    type: ShapeTypes.STAR,
                    scale: obj.scale(),
                    rotation: obj.rotation(),
                };
                break;
            case ShapeTypes.HEXAGON:
            case ShapeTypes.PENTAGON:
            case ShapeTypes.TRIANGLE:
                historyObject = {
                    x: obj.x(),
                    y: obj.y(),
                    sides: obj.sides(),
                    radius: obj.radius(),
                    fill: obj.fill(),
                    stroke: obj.stroke(),
                    strokeWidth: obj.strokeWidth(),
                    opacity: obj.opacity(),
                    type: obj.type,
                    scale: obj.scale(),
                    rotation: obj.rotation(),
                };
                break;
            default:
                historyObject = {
                    x: obj.x(),
                    y: obj.y(),
                    width: obj.width(),
                    height: obj.height(),
                    rotation: obj.rotation(),
                    scale: obj.scale(),
                    blob: meta === null || meta === void 0 ? void 0 : meta.blob,
                    opacity: obj.opacity(),
                    fill: obj.fill(),
                };
        }
        return historyObject;
    }
    catch (error) {
        return {};
    }
}
export function applyShapeHistory(object, history) {
    switch (history.type) {
        case ShapeTypes.SQUARE:
            object.setAttrs(history);
            break;
        case ShapeTypes.CIRCLE:
            object.setAttrs(history);
            break;
        case ShapeTypes.STAR:
            object.setAttrs(history);
            break;
        case ShapeTypes.TRIANGLE:
        case ShapeTypes.PENTAGON:
        case ShapeTypes.HEXAGON:
            object.setAttrs(history);
            break;
        default:
            object.setAttrs({
                x: history.x,
                y: history.y,
                width: history.width,
                height: history.height,
                rotation: history.rotation,
                scale: history.scale,
                opacity: history.opacity || 1,
            });
    }
    if (history.type) {
        object.type = history.type;
    }
}
export function getShapeNode(history) {
    return new Promise((resolve, reject) => {
        try {
            if (history.type) {
                let shape;
                switch (history.type) {
                    case ShapeTypes.SQUARE:
                        shape = new Konva.Rect(history);
                        break;
                    case ShapeTypes.CIRCLE:
                        shape = new Konva.Circle(history);
                        break;
                    case ShapeTypes.STAR:
                        shape = new Konva.Star(history);
                        break;
                    case ShapeTypes.TRIANGLE:
                    case ShapeTypes.PENTAGON:
                    case ShapeTypes.HEXAGON:
                        shape = new Konva.RegularPolygon(history);
                        break;
                }
                return resolve(shape);
            }
            if (!history.blob) {
                return reject('Blob is missing');
            }
            if (history.blob instanceof HTMLElement) {
                const imageNode = new Konva.Image({
                    x: history.x,
                    y: history.y,
                    width: history.width,
                    height: history.height,
                    rotation: history.rotation,
                    scale: history.scale,
                    image: history.blob,
                    id: history.id,
                });
                return resolve(imageNode);
            }
            else {
                const image = new Image();
                image.src = history.blob;
                image.onload = () => {
                    const imageNode = new Konva.Image({
                        x: history.x,
                        y: history.y,
                        width: history.width,
                        height: history.height,
                        rotation: history.rotation,
                        scale: history.scale,
                        image: image,
                        id: history.id,
                    });
                    resolve(imageNode);
                };
            }
        }
        catch (error) {
            // Error for getshape
            reject(error);
        }
    });
}
